import ScrollView from './ScrollView.jsx';

export default ScrollView;


// WEBPACK FOOTER //
// ./src/components/ScrollView/index.jsx